import React, {useState, useCallback} from 'react';
import {TextField, Box, CircularProgress} from '@material-ui/core';
import {apiGetClientApplications, apiSEARCHPRODUCE} from '../utils/graph';
import {Autocomplete} from '@material-ui/lab';

type TSearchAddProps = {
  onSelect?: (company: any) => void;
  type?: 'buyer' | 'produce';
  placeholder?: string;
  value?: any;
};

const SearchAdd = (props: TSearchAddProps) => {
  const [inputValue, setInputValue] = useState(props.value ?? '');
  const [options, setOptions] = useState<Array<string>>([]);
  const [results, setResults] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(false);

  // Debounce search
  const onSearch = useCallback(
    (inputValue: string) => {
      if (inputValue) {
        const delayDebounceFn = setTimeout(() => {
          setLoading(true);
          (props.type === 'buyer'
            ? apiGetClientApplications?.(inputValue)
            : apiSEARCHPRODUCE?.(inputValue, 5)
          )
            .then((results: any) => {
              setOptions(
                results.map((result: any) =>
                  props.type === 'buyer'
                    ? `${result?.company?.name}`
                    : `${result.name}`,
                ),
              );
              setResults(results);
            })
            .finally(() => setLoading(false));
        }, 300); // 300ms debounce

        return () => clearTimeout(delayDebounceFn);
      } else {
        setOptions([]);
      }
    },
    [inputValue],
  );

  const onSelect = useCallback(
    (value: string) => {
      const company = results.find((result: any) => {
        const compareValue =
          props.type === 'buyer'
            ? `${result?.company?.name}`
            : `${result.name}`;
        return compareValue === value;
      });
      if (company) {
        props?.onSelect?.(company);
      }
    },
    [props.type, props.onSelect, results],
  );

  return (
    <Box className="search-add-container">
      <Autocomplete
        freeSolo
        options={options}
        inputValue={inputValue}
        value={props?.value}
        onInputChange={(_, newValue) => {
          setInputValue(newValue);
        }}
        onChange={(event) => {
          onSelect((event?.target as any)?.textContent ?? '');
        }}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            value={props?.value}
            label={props.placeholder ?? 'Search'}
            onChange={(event) => {
              onSearch(event?.target?.value ?? '');
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default SearchAdd;
